import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import Rankings from '@/pages/home/components/Rankings';
import Categories from '@/pages/home/components/Categories';
import Recommendations from '@/pages/home/components/Recommendations';
import Reputation from '@/pages/home/components/Reputation';
import Faq from '@/pages/home/components/Faq';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Rankings />
        <Categories />
        <Recommendations />
        <Reputation />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}